import React, { useEffect } from 'react'
import Header from "../../../components/User/Header/Header"
import Footer from "../../../components/User/Footer/Footer"

function DoorToAirport() {

   useEffect(()=>{
  window.scrollTo(0,0)
    },[])

  return (
    <div className='page-wrapper'>
        <Header/>
          {/* Hero Section  */}
      <section
          class="call-to-action-one sp-four"
        //   style={{ backgroundImage: `url(${HomeBanner})` }}
        >
          <div class="container">
            <div class="sec-title-one white text-center">
              <h2>From your Door to Destination Airport Luggage service</h2>
            </div>
          </div>
        </section>
   <section className="why-chooseus sp-four">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-md-12 col-sm-12">
                <div className="choose-left-content">
                  <div className="sec-title-one">
                    {/* <h5>Our Qualification</h5> */}
                    <h2>
                      <span>Send excess baggage </span>
                      <br />  with ease
                    </h2>
                  </div>
                  <div className="text mt-45">
                    <p>
                    Are you traveling back from an exciting vacation in India? Well, then it is obvious that you are ought to bring back much more stuff that you were carrying before. And if you were already carrying enough before then this extra stuff would make you eligible for excess baggage charge. This is something that you would not be able to avoid on your own but with the help of CarryMyBaggage you can.                    </p>
                  </div>
                </div>
              </div>
              <div className="col-xl-6 col-md-12 col-sm-12">
                <div className="choose-right-area">
                  <figure>
                    <img
                      src={require("../../../images/resource/shoose-us-1.jpg")}
                      alt=""
                    />
                  </figure>
                </div>
              </div>

            </div>
            <div className="row">
              <div className="col-xl-12 col-md-12 col-sm-12">
                <div className="choose-left-content">
                  <div className="text mt-45">
                    <p>
CarryMyBaggage is a travel friendly service provider that offers to deliver your luggage from your door to airport so that you do not have to waste time at the baggage drop counter or pay excess baggage charge which would be a burden on your pocket. This service is provided from your travel destination door to your return destination airport. This is a unique service which is provided by Carry My Baggage in India. We are the pioneers of this service in India and we also have a enthusiastic team of employees who uptakes the responsibility of safely delivering your luggage to the desired location airport.
                    </p>
                    <p> <span style={{fontWeight:"700"}}>Outdoor to airport baggage</span> service is a part of our other unique services which helps you in making your travel easier than it was ever before. This not only helps you to carry all that you want to without worrying about the excess baggage charges but also do all the shopping that you want to do while vacationing.</p>
                    <p>
                    Addition to <span style={{fontWeight:"700"}} >airport baggage delivery</span>  service Carry My baggage also helps you to custom clear your shopping items on your own which means you do not have to pay unreasonably high excess baggage charge or even wait in line for custom clearance, you just need to book this service online from CarryMyBaggage and your baggage will be delivered to your desired location at the minimal possible rate.
                    </p>
                    <p>Don’t you think this is one of the best services that any modern day travel plans would be providing you with? Well, the best thing about CarryMyBaggage services is that everything can be done online, be it booking the service or tracking your baggage. Technology has definitely made travelling easy but it has also made carrying your luggage easy from one destination to the other easier.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer/>
    </div>
  )
}

export default DoorToAirport